<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file CookiesPage.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  CookiesPage.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <div class="container">
        <div class="est-privacy-widget">
            <div class="est-loading-container"></div>
            <div class="est-privacy-header est-text-light">
                <div></div>
            </div>
            <div class="est-privacy-content-box">

                <div class="est-privacy-content">
                    <div class="est-privacy-cookies card">
                        <div class="card-header">
                            <h3 class="est-uppercase">Cookies</h3>
                            <p>This site uses cookies. We take your privacy seriously and will only use personal data to
                                provide the products and
                                services you have requested from us.</p>
                            <p class="">Some of them are essentials while other help us improve your experience.</p>
                        </div>
                        <div class="est-categories-block card-body">
                            <article class="est-privacy-cookies-item">
                                <h5>Essential</h5>
                                <p>Essential cookies help make a website usable by enabling basic functions like page
                                    navigation and access to secure areas of the website. The website cannot function
                                    properly without these cookies. They also help us comply with legal requirements
                                    like GDPR.</p>
                                <p class="est-privacy-cookies-stats">
                                    <span><b>2</b> scripts</span>
                                    <span class="mx-2">|</span>
                                    <span
                                        v-on:click="show=!show"
                                        class="text-primary cursor-pointer">
                                    <template v-if="show">hide</template>
                                    <template v-else>view</template>
                                    </span>
                                </p>
                            </article>
                        </div>
                    </div>
                    <transition name="fade">
                        <article v-if="show" class="est-privacy-cookies-view card">
                            <div class="card-header">
                                <h3 class="est-uppercase">Essential</h3>
                                <p class="">Essential cookies help make a website usable by enabling basic
                                    functions
                                    like page navigation and access to secure areas of the website. The website
                                    cannot
                                    function properly without these cookies. They also help us comply with legal
                                    requirements like GDPR.</p>
                            </div>
                            <div class="card-body">
                                <h5 class="no-margin  est-darker-title">Third-party</h5>
                                <p>This is a small amount of text stored in the user's computer that is
                                    created by a website with a domain name other than the one the user is
                                    currently
                                    visiting.</p>
                                <div class=" est-privacy-cookies-info">
                                    <section>
                                        <h5>What data we collect?</h5>
                                        <p>Profile data (IP address, Browser agent data, Country and
                                            Unique
                                            identifier).
                                        </p>
                                        <p>The data you share contains sensitive personal data.</p>
                                    </section>
                                    <section class="">
                                        <h5>Why we collect it?</h5>
                                        <p>Comply with legal requirements<span class="mx-2">|</span>Legal obligation
                                        </p>
                                        <p>These cookies enable us to comply with legal requirements
                                            set
                                            up in different jurisdictions across the globe.
                                        </p>
                                    </section>
                                    <div class="est-table-container">
                                        <table class="table table-striped">
                                            <thead class="">
                                            <tr class="">
                                                <th class=" " scope="col"
                                                    style="width: 35%;">
                                                    NAME
                                                </th>
                                                <th class="" scope="col"
                                                    style="width: 20%;">
                                                    TYPE
                                                </th>
                                                <th class="" scope="col"
                                                    style="width: 20%;">
                                                    SECURE
                                                </th>
                                                <th class="" scope="col"
                                                    style="width: 25%;">
                                                    HTTP ONLY
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody class="">
                                            <tr class="">
                                                <td class=" " title="est_privacy"
                                                    style="width: 35%;">XSRF-TOKEN
                                                </td>
                                                <td class="" title="Cookie"
                                                    style="width: 20%;">Cookie
                                                </td>
                                                <td class=" " style="width: 20%;">Yes</td>
                                                <td class="" style="width: 25%;">Yes</td>
                                            </tr>
                                            <tr class="">
                                                <td class=" " title="est_privacy"
                                                    style="width: 35%;">__stripe_mid
                                                </td>
                                                <td class="" title="Cookie"
                                                    style="width: 20%;">Cookie
                                                </td>
                                                <td class=" " style="width: 20%;">Yes</td>
                                                <td class="" style="width: 25%;">Yes</td>
                                            </tr>
                                            <tr class="">
                                                <td class="" title="est_widget"
                                                    style="width: 35%;">asset_manifest
                                                </td>
                                                <td class="" title="IndexDB"
                                                    style="width: 20%;">IndexDB
                                                </td>
                                                <td class="" style="width: 20%;">No</td>
                                                <td class="" style="width: 25%;">No</td>
                                            </tr>
                                            <tr class="">
                                                <td class="" title="est_widget"
                                                    style="width: 35%;">main_nav_links
                                                </td>
                                                <td class="" title="IndexDB"
                                                    style="width: 20%;">IndexDB
                                                </td>
                                                <td class="" style="width: 20%;">No</td>
                                                <td class="" style="width: 25%;">No</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class=""><span
                                            v-on:click="show=!show"
                                            class="text-primary cursor-pointer">
                                    <template v-if="show">hide</template>
                                    <template v-else>view</template>
                                    </span></div>
                                </div>
                            </div>
                        </article>
                    </transition>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "cookiespage",
        data() {
            return {
                show: false
            }
        },

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/cookies/CookiesPage.vue